module.exports = __webpack_public_path__ + "img/s.16a9298c.webp";